import 'ui-core/plugins/stickyElements/js/stickyElements';
import {fixedHeaderHeight} from '../../../node_modules/ui-core/utility/js/utils';

UX.stickyElements.dynamicHeaderHeight = true;
UX.stickyElements.computeHeaderHeight = function () {
    this.headerHeight = fixedHeaderHeight(this.selectors['header']) + fixedHeaderHeight('.content-header');
};
UX.stickyElements.scrollThenFixActions = function (item, isHeader) {
    item.classList.add('fixed-element');
    let scrollThenFixOffset = item.querySelector(this.selectors['scrollThenFix']).offsetTop;
    scrollThenFixOffset -= !isHeader ? this.header.getBoundingClientRect().height : 0;
    item.style.top = `${-1 * scrollThenFixOffset}px`;
};
